export default __webpack_public_path__ + "static/media/D3.bff465fd.png";